/**
 * Client-only gate state for the ctx-param switch flow (#404).
 *
 * Zustand store (client state only — no server data). The phase drives what
 * CtxParamGate renders and suppresses the forced context chooser while a switch
 * is in progress.
 */

import { create } from 'zustand';
import { registerStoreReset } from '@/store/registry';

export type CtxGatePhase = 'idle' | 'waiting' | 'switching' | 'refused';

interface CtxGateState {
  phase: CtxGatePhase;
  setPhase: (phase: CtxGatePhase) => void;
}

export const useCtxGateStore = create<CtxGateState>()((set) => ({
  phase: 'idle',
  setPhase: (phase) => set({ phase }),
}));

// Sign-out resets the phase. A user switch must not (#1336): the reset would
// leave a `?ctx=` URL spinning on the switching wait (CtxParamGate).
registerStoreReset(() => useCtxGateStore.setState({ phase: 'idle' }), { onUserSwitch: false });
